// extracted by mini-css-extract-plugin
export default {"main":"styles_main__EjXzp","button":"styles_button__3dfCy"};